import * as React from 'react';

import { Button, Group, Stack, TextInput, useMantineTheme } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconChevronRight } from '@tabler/icons-react';
import GymTypeSelect from 'components/form-fields/auto-complete-fields/GymTypeSelect';
import TimeZoneSelect from 'components/form-fields/auto-complete-fields/TimeZoneSelect';
import CountrySelect from 'components/form-fields/select-fields/CountrySelect';

import { CreateDemoGymFormValues } from './types';

const CreateDemoGymModal = ({
  form,
  handleClose,
  handleStepForward,
}: {
  form: UseFormReturnType<CreateDemoGymFormValues>;
  handleClose: () => void;
  handleStepForward: () => void;
}): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Stack>
      <TextInput label='Title' required {...form.getInputProps('title')} />
      <GymTypeSelect label='Gym Type' required {...form.getInputProps('gymType')} />
      <TimeZoneSelect label='Timezone' required {...form.getInputProps('timezone')} />
      <TextInput label='Owner First Name' required {...form.getInputProps('firstName')} />
      <TextInput label='Owner Last Name' required {...form.getInputProps('lastName')} />
      <TextInput label='Owner Email' type='email' required {...form.getInputProps('email')} />
      <CountrySelect label='Country' required {...form.getInputProps('country')} />

      <Group position='right' mt='md'>
        <Button variant='default' size='md' onClick={handleClose}>
          Cancel
        </Button>
        <Button
          rightIcon={<IconChevronRight size={theme.fontSizes.md} strokeWidth={3} />}
          size='md'
          onClick={handleStepForward}
        >
          Next
        </Button>
      </Group>
    </Stack>
  );
};

export default CreateDemoGymModal;
